import { render } from "./AboutIGCSE.vue?vue&type=template&id=0c87fb82"
import script from "./AboutIGCSE.vue?vue&type=script&lang=js"
export * from "./AboutIGCSE.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__